import React from 'react';
import { Route } from 'react-router-dom';

import Home from './pages/home';

function AppRoutes() {
 return (
    <Route path="/" component={Home} />
 );
};

export default AppRoutes;